// Fancybox
// Lightbox for galleries

import "@fancyapps/fancybox";

import "@fancyapps/fancybox/dist/jquery.fancybox.css";

$.fancybox.defaults.hash = false; // Disable history which bugs out with Turbolinks enabled
